import { createElement, memo, useState } from "react";
import classNames from "classnames";
import { useTimeout } from "../../../../utils";
import { CustomSnackbarTemplate, CustomSnackbarTemplateProps } from "./templates/CustomSnackbarTemplate";
import { DefaultSnackbarTemplate, DefaultSnackbarTemplateProps } from "./templates/DefaultSnackbarTemplate";

import styles from "./style.module.scss";

export type SnackbarMessageProps = {
  removeMessage?: () => void,
  autoCloseTimeout?: number
  autoClose?: boolean
} & (DefaultSnackbarTemplateProps | CustomSnackbarTemplateProps)

export const SnackbarMessage = memo<SnackbarMessageProps>((
  {
    type = "info",
    autoCloseTimeout,
    autoClose,
    className,
    ...props
  }) => {
  const [ autoCloseTimeoutDisabled, setIsAutoCloseTimeoutDisabled ] = useState(false);
  useTimeout(props.removeMessage!, autoCloseTimeout, autoCloseTimeoutDisabled || !autoClose);

  return createElement((type === "custom" ? CustomSnackbarTemplate : DefaultSnackbarTemplate) as any, {
    ...props,
    type,
    className: classNames(className, styles.card),
    setIsAutoCloseTimeoutDisabled,
  });
});


